import React, { useState, useEffect } from "react";
import axios from "axios";

import MultiSelect from "react-multi-select-component";

import { Configs } from "../api";
const AddInput = () => {
  const [name, setname] = useState("");
  const [barItems, setItems] = useState([]);

  const [catLoc, setcatLoc] = useState("");

  const [selected, setSelected] = useState([]);

  const [options, optionsArray] = useState([]);

  const adddata = async (e) => {
    e.preventDefault();
    var opt = [];
    selected.forEach((name) => {
      // console.log(name.name);
      opt.push(name.value);
    });

    // console.log(opt);
    try {
      const result = await axios.post(Configs.specialdeal, {
        items: opt,

        price: name,
      });

      console.log(result);
      window.location.reload();
    } catch (error) {
      console.log(error.message);
    }
  };
  const loadLocations = async () => {
    // console.log(catLoc)
    try {
      const result = await axios.get(Configs.items);
      // console.log(result.data.categories)

      if (result.data.items.length !== null) {
        console.log(result.data.items.length);
        setItems(result.data.items);

        result.data.items.forEach((name) => {
          // console.log(name.name);
          options.push({
            label: name.name,
            value: name._id,
          });
        });

        // console.log(option1, "wwwww");
        // console.log(options, "wwwww");
        // console.log(virArray, "wwwww");
        console.log(result.data.items);
      } else {
        console.log("null");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    loadLocations();
  }, []);

  return (
    <div className="container-fluid">
      <h1 className="text-center mt-5">Special deal</h1>
      <form className="d-flex mt-5 mb-3 algnItm" onSubmit={adddata}>
        <input
          type="text"
          className="form-control input-styl1"
          value={name}
          onChange={(e) => setname(e.target.value)}
          required
          placeholder="Price"
        ></input>

        {/* {options} */}
        <MultiSelect
          options={options}
          value={selected}
          onChange={setSelected}
          labelledBy={"Select"}
        />

        <button className="btn btn-success">add</button>
      </form>
    </div>
  );
};

export default AddInput;
